/**
 * pressePapiers — copier un texte, et SAVOIR si ça a marché.
 *
 * Extrait de `VersionBadge`, où il vivait seul, pour que le deuxième appelant ne
 * réinvente pas un repli plus faible. Le commentaire d'origine vaut d'être gardé :
 *
 *   AVANT : le clic faisait `navigator.clipboard?.writeText(txt).then(...)`. Hors
 *   contexte sécurisé, ou permission refusée, l'optional chaining court-circuitait
 *   la chaîne entière : rien n'était copié, la coche de confirmation ne s'affichait
 *   jamais, et le bouton semblait simplement mort.
 *
 * D'où le booléen rendu : un appelant qui l'ignore affichera une confirmation
 * mensongère.
 *
 * @param {string} txt
 * @returns {Promise<boolean>} vrai si le texte est bien dans le presse-papiers
 */
export async function copierDansPressePapiers(txt) {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(txt);
            return true;
        }
    } catch { /* permission refusée ou origine non sécurisée : on tente le repli */ }
    try {
        const ta = document.createElement('textarea');
        ta.value = txt;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok === true;
    } catch {
        return false;
    }
}
